export default __webpack_public_path__ + "static/media/logo.d8e3adb3.png";